import React from "react";
import {router, usePage} from "@inertiajs/react";
import {useLaravelReactI18n} from "laravel-react-i18n";
import InertiaTable from "laravel-inertia-react-table";
import {mdiPlus} from "@mdi/js";
import Icon from "@mdi/react";
import {Button} from "react-bootstrap";
import {ChartComponent} from "../Components/ChartComponent.jsx";

export default function Chart(props) {
    const {t} = useLaravelReactI18n();
    const {chartData} = usePage().props;
    const handleAddClick = () => {
        router.get('chart/create');
    }

    return (<ChartComponent className={"h-100"} {...props} series={chartData}></ChartComponent>);
}



